// Field list for the default-overlay editor, from the registry's own metadata.
//
// Extracted from the page for the same reason initialOverlay.js was: importing the page
// drags in axios and MUI, which the test transform can't take.
//
// Auto-filled fields (the packed sponsor URLs behind the sponsors area) are marked
// selectable: false and stay out of the palette — a matching SVG id still places
// them, they just aren't something a designer picks and drops.
export function fieldsFromSampleValues(fields) {
  if (!Array.isArray(fields)) return []
  return fields
    .filter((f) => f.selectable !== false)
    .map((f) => ({
      key: f.key,
      label: f.label ?? f.key,
      dataType: f.dataType ?? 'Text',
      isLive: f.isLive ?? false,
      numeric: f.numeric ?? false,
      formats: f.formats ?? undefined,
      sampleValue: f.sampleValue,
    }))
}
